import api from '../../../api';
import socketPromise from '../../../websocket';
import * as receiveMessage from '../../../modules/trader-chat/actions/receive-message';
import * as userTyping from '../../../modules/trader-chat/actions/user-typing';
import * as getChat from '../../../modules/trader-chat/actions/get-chat';
import debounce from 'lodash/debounce';

function subscribe(dispatch, socket, chatId) {
    let debounceStop = debounce(function (stopChatId) {
        dispatch(userTyping.stop(stopChatId));
    }, 5000);
    socket.emit('subscribe', chatId + ':Chat');

    socket.removeAllListeners(chatId + ':Chat');

    socket.on(chatId + ':Chat', msg => {
        let body = JSON.parse(msg).body;
        if (body.type === 'typing') {
            dispatch(userTyping.start(chatId));
            debounceStop(chatId);
        } else {
            dispatch(receiveMessage.receive(chatId, body));
            dispatch(userTyping.stop(chatId));
        }
    });
}

export function request(dispatch, { chatId }) {
    api.get('/chats/' + chatId)
        .then(
            (data) => dispatch(getChat.finish(chatId, data)),
            (data) => dispatch(getChat.error(chatId, data.errors))
        )
        .then(() => socketPromise)
        .then(socket => {
            subscribe(dispatch, socket, chatId);
            socket.on('auth', () => subscribe(dispatch, socket, chatId));
        });
}

